import React from "react";
import PropTypes from "prop-types";
import searchIcon from "../../assets/img/search.svg";

// The built-in search renders whenever an `onSearchChange` handler is given —
// pages may combine it with `toolbarLeft` (Policies tabs, Rate Plans filter).
// Pages that manage their own search UI (e.g. Derived Rate Plans, which puts
// its search inside `toolbarLeft`) simply omit `onSearchChange`.
const PropertyPageCard = ({
  searchQuery = "",
  onSearchChange,
  searchPlaceholder = "Search",
  searchAriaLabel,
  toolbarLeft = null,
  toolbarRight = null,
  children,
}) => (
  <div className="property-page-card">
    <div className="property-page-card__toolbar">
      <div className="property-page-card__toolbar-left">{toolbarLeft}</div>
      {onSearchChange && (
        <div className="property-page-card__search-wrapper">
          <div className="property-page-card__search">
            <img
              src={searchIcon}
              alt=""
              className="property-page-card__search-icon"
            />
            <input
              type="text"
              className="property-page-card__search-input"
              placeholder={searchPlaceholder}
              aria-label={searchAriaLabel || searchPlaceholder}
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
            />
          </div>
        </div>
      )}
      {toolbarRight && (
        <div className="property-page-card__toolbar-right">{toolbarRight}</div>
      )}
    </div>
    <div className="property-page-card__table-wrapper">{children}</div>
  </div>
);

PropertyPageCard.propTypes = {
  searchQuery: PropTypes.string,
  onSearchChange: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  searchAriaLabel: PropTypes.string,
  toolbarLeft: PropTypes.node,
  toolbarRight: PropTypes.node,
  children: PropTypes.node,
};

export default PropertyPageCard;
